import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import { normalizeError } from '@vega/services'
import { uploadFile } from '@vega/redux.upload'

import { supportingDocumentService } from 'apiService'

export const listSupportingDocuments = createAsyncThunk(
  'supportingDocument/listSupportingDocuments',
  async ({ versionedLoanApplicationId, loanApplicationId }, { rejectWithValue }) => {
    try {
      return await supportingDocumentService.list(
        versionedLoanApplicationId,
        loanApplicationId
      )
    } catch (err) {
      const error = await normalizeError(err)
      return rejectWithValue(error)
    }
  }
)

export const createSupportingDocument = createAsyncThunk(
  'supportingDocument/createSupportingDocument',
  async (
    {
      classification,
      file,
      versionedLoanApplicationId,
      loanApplicationId,
      references,
      source,
      logDownload,
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      let [fileName, fileType] = ''
      if (!logDownload) {
        const { name, type } = file
        fileName = name
        fileType = type
      } else if (logDownload) {
        fileName = file
      }

      const result = await supportingDocumentService.create(
        classification,
        fileName,
        fileType,
        source,
        versionedLoanApplicationId,
        loanApplicationId,
        references,
        logDownload
      )

      if (!logDownload) {
        const fileToUpload = { presignedUrl: result.presignedUrl, fileDetails: file }

        await dispatch(uploadFile(fileToUpload))
      }

      return {
        classification,
        file,
        versionedLoanApplicationId,
        loanApplicationId,
        presignedUrl: result.presignedUrl,
      }
    } catch (err) {
      const error = await normalizeError(err)
      return rejectWithValue(error)
    }
  }
)

export const supportingDocumentAdapter = createEntityAdapter()

const initialState = supportingDocumentAdapter.getInitialState()

const supportingDocumentSlice = createSlice({
  name: 'supportingDocument',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listSupportingDocuments.fulfilled, (state, { payload }) =>
      supportingDocumentAdapter.setAll(state, payload)
    )
  },
})

const { reducer: supportingDocumentReducer } = supportingDocumentSlice

export { supportingDocumentReducer }
